import { Attributes } from '@leverege/ui-attributes';
function sort(a, b) {
  const as = a.blueprint?.attribute?.getTagStartingWith?.('formSort:', true) || 'zzz';
  const bs = b.blueprint?.attribute?.getTagStartingWith?.('formSort:', true) || 'zzz';
  return as.localeCompare(bs);
}
function defaultGetAttributes(target, extraFilter) {
  const attrs = Attributes.getAttributesFor(target?.type);
  const pathHT = {};
  const avail = attrs.reduce((acc, attr) => {
    if (attr?.blueprint?.editable && attr?.blueprint?.updatePath && attr?.blueprint?.renamed !== true && (extraFilter == null || extraFilter(attr) === true) && !pathHT[attr.blueprint.updatePath]) {
      pathHT[attr.blueprint.updatePath] = true;
      acc.push(attr);
    }
    return acc;
  }, []);
  return avail;
}
function filterAttributeFilterTag(tag) {
  return attr => {
    const attribute = attr?.blueprint?.attribute;
    if (attribute) {
      return !attribute.hasTag(tag);
    }
    return true;
  };
}
function bulkCreateAttributeFilter(attr) {
  const attribute = attr?.blueprint?.attribute;
  if (attribute) {
    return !attribute.hasTag('bulkCreate:exclude') && !attribute.hasTag('is:resourceImage');
  }
  return true;
}
function bulkUpdateAttributeFilter(attr) {
  const attribute = attr?.blueprint?.attribute;
  if (attribute) {
    return !attribute.hasTag('bulkUpdate:exclude') && !attribute.getTagStartingWith('externalId') && !attribute.hasTag('is:resourceImage');
  }
  return true;
}
export default {
  sort,
  filterAttributeFilterTag,
  defaultGetAttributes,
  bulkCreateAttributeFilter,
  bulkUpdateAttributeFilter
};